import { GlDisclosureDropdown, GlDisclosureDropdownGroup, GlDisclosureDropdownItem, GlBadge, GlIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { __, s__, sprintf, n__ } from '~/locale';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import AiCatalogItemUserAttribution from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/ai_catalog_item_user_attribution.vue?vue3';
import FoundationalIcon from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/components/foundational_icon.vue?vue3';
import { resolveVersion, isGitLabMaintainedItem } from '../utils';
import { isAiCatalogItemEnabledInGroup, isAiCatalogItemEnabledInProject } from '../capabilities';
import { AI_CATALOG_TYPE_THIRD_PARTY_FLOW, AI_CATALOG_TYPE_FOUNDATIONAL_AGENT, AI_CATALOG_CONSUMER_TYPE_PROJECT, AI_CATALOG_CONSUMER_TYPE_GROUP, AI_CATALOG_CONSUMER_LABELS, TRACK_EVENT_DISABLE_AI_CATALOG_ITEM, TRACK_EVENT_ITEM_TYPES, TRACK_EVENT_ORIGIN_PROJECT, TRACK_EVENT_ORIGIN_GROUP, TRACK_EVENT_PAGE_LIST, VISIBILITY_LEVEL_LABELS, VISIBILITY_TYPE_ICON } from '../constants';
import { getRegistryItem } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/item_type_registry.js?vue3';
export default {
    name: 'AiCatalogListItem',
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        AiCatalogItemUserAttribution,
        GlBadge,
        GlIcon,
        FoundationalIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        SafeHtml
    },
    mixins: [
        InternalEvents.mixin()
    ],
    inject: {
        isGlobalNamespace: {},
        isProjectNamespace: {},
        isGroupNamespace: {}
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        itemTypeConfig: {
            type: Object,
            required: false,
            default: ()=>({})
        }
    },
    emits: [
        'disable'
    ],
    computed: {
        itemRegistry () {
            return getRegistryItem(this.item.itemType);
        },
        itemTypeLabel () {
            return this.itemRegistry.label;
        },
        targetType () {
            return this.isProjectNamespace ? AI_CATALOG_CONSUMER_TYPE_PROJECT : AI_CATALOG_CONSUMER_TYPE_GROUP;
        },
        resolvedVersionKey () {
            return resolveVersion(this.item, {
                isGlobalNamespace: this.isGlobalNamespace,
                isGroupNamespace: this.isGroupNamespace
            }).key;
        },
        targetTypeLabel () {
            return AI_CATALOG_CONSUMER_LABELS[this.targetType];
        },
        actionItems () {
            return this.itemTypeConfig.actionItems?.(this.item) || [];
        },
        showDisableAction () {
            return this.itemTypeConfig.disableActionItem?.showActionItem?.(this.item);
        },
        hasActionItems () {
            return this.actionItems.length > 0;
        },
        showActions () {
            return this.showDisableAction || this.hasActionItems;
        },
        formattedItemId () {
            return getIdFromGraphQLId(this.item.id);
        },
        isFoundationalAgent () {
            return this.item.itemType === AI_CATALOG_TYPE_FOUNDATIONAL_AGENT;
        },
        showItemRoute () {
            const { routes } = this.itemRegistry;
            return this.isFoundationalAgent ? {
                name: routes.show,
                params: {
                    reference: this.item.reference
                }
            } : {
                name: routes.show,
                params: {
                    id: this.formattedItemId
                }
            };
        },
        disableActionItem () {
            return {
                text: this.itemTypeConfig.disableActionItem?.text || __('Disable')
            };
        },
        visibilityProps () {
            const { visibility } = this.item;
            return {
                iconName: VISIBILITY_TYPE_ICON[visibility],
                tooltip: this.itemRegistry.visibilityDescriptions?.[visibility],
                label: VISIBILITY_LEVEL_LABELS[visibility]
            };
        },
        isSourceProjectNull () {
            return !this.item.project?.nameWithNamespace;
        },
        sourceProjectName () {
            return this.isSourceProjectNull ? s__('AICatalog|Private') : this.item.project?.nameWithNamespace;
        },
        sourceProjectTooltip () {
            return this.isSourceProjectNull ? s__("AICatalog|Managed by a private project you don't have access to.") : this.item.project?.nameWithNamespace;
        },
        isGitLabMaintained () {
            return isGitLabMaintainedItem(this.item);
        },
        isThirdPartyFlow () {
            return this.item.itemType === AI_CATALOG_TYPE_THIRD_PARTY_FLOW;
        },
        statusBadge () {
            if (!this.itemTypeConfig.showStatusBadge || isAiCatalogItemEnabledInProject(this.item)) {
                return null;
            }
            const isEnabledInGroup = isAiCatalogItemEnabledInGroup(this.item);
            return {
                title: isEnabledInGroup ? s__('AICatalog|Ready to enable') : s__('AICatalog|Pending approval'),
                variant: isEnabledInGroup ? 'success' : 'warning',
                tooltipText: isEnabledInGroup ? sprintf(s__('AICatalog|To use this %{itemType}, a user with at least the Maintainer role must enable it in this project.'), {
                    itemType: this.itemTypeLabel
                }) : sprintf(s__('AICatalog|To use this %{itemType}, a user with the Owner role must enable it in the top-level group.'), {
                    itemType: this.itemTypeLabel
                })
            };
        },
        softDeletedTooltipText () {
            return sprintf(s__('AICatalog|This %{itemType} was removed from the AI Catalog. You can still use it in this %{targetType}.'), {
                itemType: this.itemTypeLabel,
                targetType: this.targetTypeLabel
            });
        },
        starCountAriaLabel () {
            return n__('%d star', '%d stars', this.item.starCount);
        },
        usageCountAriaLabel () {
            return n__('%d project', '%d projects', this.item.last30DayUsageCount);
        }
    },
    methods: {
        onClickDisable () {
            this.$emit('disable');
            this.trackEvent(TRACK_EVENT_DISABLE_AI_CATALOG_ITEM, {
                label: TRACK_EVENT_ITEM_TYPES[this.item.itemType],
                origin: this.isProjectNamespace ? TRACK_EVENT_ORIGIN_PROJECT : TRACK_EVENT_ORIGIN_GROUP,
                page: TRACK_EVENT_PAGE_LIST
            });
        }
    }
};
